<template>
  <v-avatar left :size="size">
    <v-img :src="img" @error="imageError = true" :lazy-src="defaultImage" />
  </v-avatar>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: ["src", "userId", "size"],
  data() {
    return {
      imageError: false,
      defaultImage: require("@/assets/no-avatar.svg"),
    };
  },
  computed: {
    img() {
      return this.imageError ? this.defaultImage : this.src ? this.src : this.imgSrcByUserId;
    },
    imgSrcByUserId() {
      const cloudStorageBucketPath = process.env.VUE_APP_CLOUD_STORAGE_BUCKET;
      return `https://storage.googleapis.com/${cloudStorageBucketPath}${this.userId}.jpg?ignoreCache=1`;
    },
  },
  watch: {
    src() {
      this.imageError = false;
    },
  },
});
</script>
